import AuthGuard from '@components/AuthGuard';
import StampSheet from '@components/StampSheet';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import useAttendanceCheck from '../../hooks/useAttendanceCheck';
import useAttendanceEvent from '../../hooks/useAttendanceEvent';

interface Props {
    eventId: string;
}

function Sheet({ eventId }:Props) {
    const { t } = useTranslation('event');
    const { policy, progress } = useAttendanceEvent(eventId);
    const handleCheckIn = useAttendanceCheck(eventId, 'TOUCH_STAMP');

    if (policy?.checkInType === 'TOUCH_STAMP') {
        return (
            <AuthGuard>
                <Wrapper>
                    <StampSheet backgroundImageUrl={policy?.touchStampBackgroundImageUrl}
                        onSuccess={handleCheckIn} />
                    {progress?.isAllCompleted && (
                        <Dim onTouchStart={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }}>
                            <Text fontWeight='semibold' color={colors.white} size='display'
                                css={css`
                            transform: rotate(-15deg);
                        `} >
                                {t('attendance.missionComplete')}
                            </Text>
                        </Dim>
                    )}
                </Wrapper>
            </AuthGuard>
        );
    }
    return null;
}

const Wrapper = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 1;
`;

const Dim = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
`;

export default Sheet;
